import $ from 'jquery';
const urls = [
  'https://magazine.fastcompany.com/pubs/FC/FST/FST_PageID_Control_10for1299_rspcopy.jsp?cds_page_id=196850&cds_mag_code=FST&id=1458587251694&lsid=60811352362041472&vid=2&cds_response_key=IB6AFE0CA',
  'https://magazine.fastcompany.com/loc/FST/navcharger'
];
export default function () {
  const int = Math.floor(Math.random() * urls.length);
  const url = urls[int];
  $('.js-nav-subscribe').each(function changeHref(index, el) {
    $(el).attr('href', url);
  });
}
